import { render, staticRenderFns } from "./ActivityTotalScoreListInstructor.vue?vue&type=template&id=1388a2e6&"
import script from "./ActivityTotalScoreListInstructor.vue?vue&type=script&lang=js&"
export * from "./ActivityTotalScoreListInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports